import React, {Fragment} from 'react';
import {FaRegularIcon, FaSolidIcon} from "../../FontAwesomeIcons";
import {WAITING_LIST_SHOPS} from "../Constants";
import {NegozioOpenStore} from "../../../stores/NegozioOpenStore";
import {PluralString} from "../../../helpers/UIUtility";

export function SessionCardView(props) {

    const sessione = props.session

    function getOccupancyLabel(capienza, disp) {
        if (props.hideAvailability && disp) {
            return <span className={"text-success"}>Posti disponibili</span>
        }

        //Se ci sono abbastanza posti disponibili per i partecipanti
        if(sessione.posti_disponibili >= props.partecipanti){
            const prenotazioni = capienza - Math.max(0, disp);
            const occupancyPerc = prenotazioni / capienza * 100;

            if (occupancyPerc >= 50) return <small className={"text-warning"}>{disp} posti disponibili</small>

            return <small className={"text-success"}>{disp} posti disponibili</small>
        }

        //Se sono arrivato quì vuol dire che non ci sono abbastanza posti
        let noPlaceLabel = disp <= 0 ?
            "Esaurito" :
            <span>Solo <PluralString n={disp} more={disp+ " posti disponibili"} single={"un posto disponibile"}/> su {props.partecipanti}</span>

        //Se non è abilitata la lista d'attesa posso ritornare
        if(!WAITING_LIST_SHOPS.includes(parseInt(NegozioOpenStore.infoNegozio.id_negozio))){
            return <small className={"text-muted"}>{noPlaceLabel}</small>
        }
        return <small className={"text-muted"}>{noPlaceLabel}, avvisami se torna disponibile <FaSolidIcon name={"bell"}/></small>
    }

    function handleTimeChange() {
        props.onSessionChoose(sessione)
    }

    function handleFullGroupSessionChoose() {
        props.onSessionChoose(sessione, 1)
    }

    console.log("QUI", sessione.posti_disponibili, props.partecipanti)
    return <div className={"col-12 px-2 text-center"}>
        {
            (sessione.posti_disponibili >= props.partecipanti) ?
                <label className={"fux-radiobox bg-main-z2 d-block shadow-sm py-2 text-on-bg-main"} style={{fontSize: "1em"}}>
                    <input type={"checkbox"} value={sessione} name={"orario_prenotazione"} checked={props.checked}
                           onChange={handleTimeChange.bind(this)}/>
                    {
                        props.checked ? <FaSolidIcon name={"check-circle"}/> : <FaRegularIcon name={"circle"}/>
                    }&nbsp;
                    {
                        props.hideEndTime ?
                            <Fragment>Alle {sessione.orario_inizio}</Fragment> :
                            <Fragment>Dalle {sessione.orario_inizio} alle {sessione.orario_fine}</Fragment>
                    }
                    <div>
                        {getOccupancyLabel(sessione.max_partecipanti, sessione.posti_disponibili)}
                    </div>
                    {
                        sessione.accessori && sessione.accessori.map((a, i) => {
                            return <div key={i} className={"small text-muted"}>{a.disponibilita} {a.nome} disponibili</div>
                        })
                    }
                </label>
                :
                <div className={"bg-main-z2 d-block shadow-sm p-2 text-on-bg-main my-1"} style={{fontSize: "1em"}} onClick={handleFullGroupSessionChoose}>
                    {
                        props.hideEndTime ?
                            <div className={"text-muted"}>Alle {sessione.orario_inizio}</div> :
                            <div className={"text-muted"}>Dalle {sessione.orario_inizio} alle {sessione.orario_fine}</div>
                    }
                    <div className={"text-muted"}>
                        {getOccupancyLabel(sessione.max_partecipanti, sessione.posti_disponibili)}
                    </div>
                </div>
        }
    </div>
}